import request from '@/core/http/request'

const SYS_NUMBER_BASE = '/qingguang/cooperativesupplier/sysNumber'

// 生成编号（协同端不能走 tenantbussiness；方法名与原 XTLogin 网关一致）
export function sysNumber_queryNumberLength(data) {
  return request({
    url: SYS_NUMBER_BASE + '/sysNumber.queryNumberLength',
    method: 'post',
    data: data
  })
}

// 批量生成编号（产品标签码）
export function sysNumber_batchQueryNumberLength(data) {
  return request({
    url: SYS_NUMBER_BASE + '/sysNumber.batchQueryNumberLength',
    method: 'post',
    data: data
  })
}

// 新增自定义菜单
export function sysUserMenu_add(data) {
  return request({
    url: '/qingguang/cooperativesupplier/sysUserMenu/add',
    method: 'post',
    data: data
  })
}

// 修改自定义菜单
export function sysUserMenu_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysUserMenu/update',
    method: 'post',
    data: data
  })
}

// 查询用户menu设置数据
export function sysUserMenu_query_setting(data) {
  return request({
    url: '/qingguang/cooperativesupplier/sysUserMenu/query.setting',
    method: 'post',
    data: data
  })
}

// 初始化数据
export function checkInitialization(data) {
  return request({
    url: '/admin/upms/login/checkInitialization',
    method: 'post',
    data: data
  })
}

// 三大主体自定义字段
export function sysEntityExtControl_listByType(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysEntityExtControl/listByFilter',
    method: 'post',
    data: data
  })
}

// 三大主体新增自定义字段
export function sysEntityExtControl_add(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysEntityExtControl/add',
    method: 'post',
    data: data
  })
}

// 三大主体修改自定义字段
export function sysEntityExtControl_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysEntityExtControl/update',
    method: 'post',
    data: data
  })
}

// 查询订单自定义字段
export function sysDocExtControl_listByType(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysDocExtControl/listByFilter',
    method: 'post',
    data: data
  })
}

// 修改订单自定义字段
export function sysDocExtControl_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysDocExtControl/update',
    method: 'post',
    data: data
  })
}

// 打印模板列表
export function sysPrint_list(data) {
  return request({
    url: '/qingguang/cooperativesupplier/sysPrint/listByFilter',
    method: 'post',
    data: data
  })
}

// 新增打印模板
export function sysPrint_add(data) {
  return request({
    url: '/qingguang/cooperativesupplier/sysPrint/add',
    method: 'post',
    data: data
  })
}

// 添加打印记录
export function sysPrintHistoryContent_add(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysPrintHistoryContent/add',
    method: 'post',
    data: data
  })
}

// 打印记录
export function sysPrintHistoryContent_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysPrintHistoryContent/list',
    method: 'post',
    data: data
  })
}

// 修改打印模板
export function sysPrint_update(data) {
  return request({
    url: '/qingguang/cooperativesupplier/sysPrint/update',
    method: 'post',
    data: data
  })
}

// 打印模板详情
export function sysPrint_view(data) {
  return request({
    url: '/qingguang/cooperativesupplier/sysPrint/view',
    method: 'get',
    params: data
  })
}

// 打印模板删除
export function sysPrint_delete(data) {
  return request({
    url: '/qingguang/cooperativesupplier/sysPrint/delete',
    method: 'post',
    data: data
  })
}
// 打印修改默认
export function sysPrint_setDefault(data) {
  return request({
    url: '/qingguang/cooperativesupplier/sysPrint/setDefault',
    method: 'post',
    data: data
  })
}

// 查询默认打印模板
export function sysPrint_getDefaultByModules(data) {
  return request({
    url: '/qingguang/cooperativesupplier/sysPrint/getDefaultByModules',
    method: 'post',
    data: data
  })
}

/** 从 ERP（tenant）同步打印模板到协同端 */
export function sysPrint_syncFromTenant(data) {
  return request({
    url: '/qingguang/cooperativesupplier/sysPrint/syncFromTenant',
    method: 'post',
    data: data || {}
  })
}

// 审核配置
export function sysDocExamineConfig_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysDocExamineConfig/list',
    method: 'post',
    data: data
  })
}

// 修改审核配置
export function sysDocExamineConfig_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysDocExamineConfig/update',
    method: 'post',
    data: data
  })
}

// 查询是否能审核
export function sysDocExamineConfig_canCheckDocByDocType(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysDocExamineConfig/canCheckDocByDocType',
    method: 'post',
    data: data
  })
}

// 质检配置
export function sysQualityInspectionConfig_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysQualityInspectionConfig/list',
    method: 'post',
    data: data
  })
}

// 修改质检配置
export function sysQualityInspectionConfig_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysQualityInspectionConfig/update',
    method: 'post',
    data: data
  })
}

// 上传文件
export function upload(data) {
  return request({
    url: '/qingguang/tenantbussiness/common/upload',
    method: 'post',
    data: data
  })
}

// 按钮配置
export function sysDocCirculationConfig_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysDocCirculationConfig/listByPageId',
    method: 'post',
    data: data
  })
}

// 修改按钮配置
export function sysDocCirculationConfig_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysDocCirculationConfig/update',
    method: 'post',
    data: data
  })
}

// 查询页面显示按钮(老接口)
export function sysDocCirculationConfig_listButtonCanShow(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysDocCirculationConfig/listButtonCanShow',
    method: 'post',
    data: data
  })
}

// 查询页面显示按钮(新接口)
export function sysButtonConfig_listButtonCanShow(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysButtonConfig/listButtonCanShow',
    method: 'post',
    data: data
  })
}

// 根据页面ID查询列表背景颜色配置
export function sysBackgroundColorSetting_listByFilter(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysBackgroundColorSetting/listByFilter',
    method: 'post',
    data: data
  })
}

// 新增列表背景颜色配置
export function sysBackgroundColorSetting_add(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysBackgroundColorSetting/add',
    method: 'post',
    data: data
  })
}

// 修改列表背景颜色配置
export function sysBackgroundColorSetting_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysBackgroundColorSetting/update',
    method: 'post',
    data: data
  })
}

// 查询页面字段显示
export function field_show(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysEntityMainControl/listByTypeId',
    method: 'post',
    data: data
  })
}

// 查询页面字段列表显示
export function field_showOnly(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysEntityMainControl/listShowByTypeId',
    method: 'post',
    data: data
  })
}

// 查询页面字段显示更新
export function field_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysEntityMainControl/update',
    method: 'post',
    data: data
  })
}

// 查询页面必填字段显示校验
export function listRequired_showOnly(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysEntityMainControl/listRequiredByTypeId',
    method: 'post',
    data: data
  })
}

// 获取客户物流信息
export function listByCustomerId(data) {
  return request({
    url: '/qingguang/tenantbussiness/customerShippingInfo/listByCustomerId',
    method: 'get',
    params: data
  })
}
// 获取供应商物流信息
export function listBySupplierId(data) {
  return request({
    url: '/qingguang/tenantbussiness/supplierShippingInfo/listBySupplierId',
    method: 'get',
    params: data
  })
}

// 获取特性编码开关
export function characteristicSwitch_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/characteristicSwitch/list',
    method: 'post',
    data: data
  })
}

// 修改特性编码开关
export function characteristicSwitch_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/characteristicSwitch/update',
    method: 'post',
    data: data
  })
}

// 根据key获取
export function getCharacteristicSwitchByKey(data) {
  return request({
    url: '/qingguang/tenantbussiness/characteristicSwitch/getCharacteristicSwitchByKey',
    method: 'post',
    data: data
  })
}

// 根据文件ID获取新文件
export function fileInfo_getFileId(data) {
  return request({
    url: '/qingguang/tenantbussiness/fileInfo/getFileId',
    method: 'post',
    data: data
  })
}

// 修改单据自定义字段
export function sysDocExt_updateByRelId(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysDocExt/updateByRelId',
    method: 'post',
    data: data
  })
}

// 修改主体自定义字段
export function sysEntityExt_updateByRelId(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysEntityExt/updateByRelId',
    method: 'post',
    data: data
  })
}

// 编码引擎List接口
export function sysNumberConfig_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysNumberConfig/list',
    method: 'post',
    data: data
  })
}

// 编码引擎更新接口
export function sysNumberConfig_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysNumberConfig/update',
    method: 'post',
    data: data
  })
}

// 新增页面缓存
export function sysDocCache_saveNewOrUpdate(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysDocCache/saveNewOrUpdate',
    method: 'post',
    data: data
  })
}

// 查询页面缓存
export function sysDocCache_getSysDocCacheVoByKey(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysDocCache/getSysDocCacheVoByKey',
    method: 'post',
    data: data
  })
}
    
// 全局搜索码更新
export function sysNumberConfig_creatSysNumber(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysNumberConfig/creatSysNumber',
    method: 'get',
    params: data
  })
}

// 进销存模块报价单待审核单据数量
export function selectSalesQuotationListCountWhileCheck(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesQuotationDocDetail/selectSalesQuotationListCountWhileCheck',
    method: 'post',
    data: data
  })
}

// 进销存模块销售订单待审核单据数量
export function selectSalesOrderListCountWhileCheck(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesOrderDocDetail/selectSalesOrderListCountWhileCheck',
    method: 'post',
    data: data
  })
}

// 进销存模块销售出库单待审核单据数量
export function selectSalesDeliveryListCountWhileCheck(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesDeliveryDocDetail/selectSalesDeliveryListCountWhileCheck',
    method: 'post',
    data: data
  })
}

// 进销存模块销售退货单待审核单据数量
export function selectSalesChargebackOrderListCountWhileCheck(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesChargebackDocDetail/selectSalesChargebackOrderListCountWhileCheck',
    method: 'post',
    data: data
  })
}

// 进销存模块销售账单待审核单据数量
export function getStatementDocListCountWhileCheck(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesStatementDoc/getStatementDocListCountWhileCheck',
    method: 'post',
    data: data
  })
}

// 进销存模块样品单待审核单据数量
export function selectSalesSampleDocListCountWhileCheck(data) {
  return request({
    url: '/qingguang/tenantbussiness/smgtSalesSampleDocDetail/selectSalesSampleDocListCountWhileCheck',
    method: 'post',
    data: data
  })
}

// 进销存模块采购订单待审核单据数量
export function selectPurchasesOrderListCountWhileCheck(data) {
  return request({
    url: '/qingguang/tenantbussiness/pmgtPurchasesOrderDocDetail/selectPurchasesOrderListCountWhileCheck',
    method: 'post',
    data: data
  })
}

// 进销存模块采购入库单待审核单据数量
export function selectPurchasesReceiptListCountWhileCheck(data) {
  return request({
    url: '/qingguang/tenantbussiness/pmgtPurchasesReceiptDocDetail/selectPurchasesReceiptListCountWhileCheck',
    method: 'post',
    data: data
  })
}

// 进销存模块采购退货单待审核单据数量
export function getPurchasesChargebackOrderListCountWhileCheck(data) {
  return request({
    url: '/qingguang/tenantbussiness/pmgtPurchasesChargebackDocDetail/getPurchasesChargebackOrderListCountWhileCheck',
    method: 'post',
    data: data
  })
}

// 进销存模块请购单待审核单据数量
export function selectUnPurchasesRequisitionDocListCountWhileCheck(data) {
  return request({
    url: '/qingguang/tenantbussiness/pmgtPurchasesRequistionDoc/selectUnPurchasesRequisitionDocListCountWhileCheck',
    method: 'post',
    data: data
  })
}

// 进销存模块采购账单待审核单据数量
export function getPurchaseStatementDocListCountWhileCheck(data) {
  return request({
    url: '/qingguang/tenantbussiness/pmgtPurchasesStatementDoc/getPurchaseStatementDocListCountWhileCheck',
    method: 'post',
    data: data
  })
}

// 进销存模块请款单待审核单据数量
export function selectRequestFundsListCountWhileCheck(data) {
  return request({
    url: '/qingguang/tenantbussiness/requestFunds/selectRequestFundsListCountWhileCheck',
    method: 'post',
    data: data
  })
}

// 进销存模块报销单待审核单据数量
export function getReimburseDocListCountWhileCheck(data) {
  return request({
    url: '/qingguang/tenantbussiness/reimburseDoc/getReimburseDocListCountWhileCheck',
    method: 'post',
    data: data
  })
}

// 进销存模块精细报价单单待审核单据数量
export function selectFineQuotationDocListCountWhileCheck(data) {
  return request({
    url: '/qingguang/tenantbussiness/fineQuotationDocDetail/selectFineQuotationDocListCountWhileCheck',
    method: 'post',
    data: data
  })
}

// 首页未审核数据汇总（生产）
export function bom_getMesTotalCount(data) {
  return request({
    url: '/qingguang/tenantbussiness/bom/getMesTotalCount',
    method: 'post',
    data: data
  })
}

// 付款方式listby
export function sysPaymentListBy(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysPaymentMethodConfig/listBy',
    method: 'post',
    data: data
  })
}

// 付款方式Method
export function getSysPaymentMethodConfigListByTransactionMethod(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysPaymentMethodConfig/getSysPaymentMethodConfigListByTransactionMethod',
    method: 'post',
    data: data
  })
}

// 付款方式list
export function sysPaymentList(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysPaymentMethodConfig/list',
    method: 'post',
    data: data
  })
}

// 付款方式Add
export function sysPaymentAdd(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysPaymentMethodConfig/add',
    method: 'post',
    data: data
  })
}

// 付款方式update
export function sysPaymentUpdate(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysPaymentMethodConfig/update',
    method: 'post',
    data: data
  })
}

// 付款方式 delete
export function sysPaymentDelete(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysPaymentMethodConfig/delete',
    method: 'post',
    data: data
  })
}

// 批量下载文件
export function download_download(data) {
  return request({
    url: '/qingguang/tenantbussiness/download/download',
    method: 'post',
    data: data
  })
}

// 编号验证重复
export function sysGlobalNumber_canUseIndexDocNumber(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysGlobalNumber/canUseIndexDocNumber',
    method: 'get',
    params: data
  })
}

// 根据全局搜索码查询关联单据
export function sysGlobalNumber_getSysGlobalNumberInfoListByGlobalSearchNumber(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysGlobalNumber/getSysGlobalNumberInfoListByGlobalSearchNumber',
    method: 'post',
    data: data
  })
}

// 根据全局搜索码查询关联单据(画图)
export function sysDocRelation_getSysDocRelationListByIds(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysDocRelation/getSysDocRelationListByIds',
    method: 'post',
    data: data
  })
}

// 数据填报配置新增
export function sysTenantModelSetting_add(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysTenantModelSetting/add',
    method: 'post',
    data: data
  })
}

// 数据填报配置查询
export function sysTenantModelSetting_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysTenantModelSetting/list',
    method: 'post',
    data: data
  })
}

// 数据填报配置修改
export function sysTenantModelSetting_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysTenantModelSetting/update',
    method: 'post',
    data: data
  })
}

// 数据填报配置删除
export function sysTenantModelSetting_delete(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysTenantModelSetting/delete',
    method: 'post',
    data: data
  })
}

// 数据填报新增
export function sysTenantModelData_add(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysTenantModelData/add',
    method: 'post',
    data: data
  })
}

// 数据填报修改
export function sysTenantModelData_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysTenantModelData/update',
    method: 'post',
    data: data
  })
}

// 数据填报新增
export function sysTenantModelData_delete(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysTenantModelData/delete',
    method: 'post',
    data: data
  })
}

// 数据填报新增
export function sysTenantModelData_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysTenantModelData/list',
    method: 'post',
    data: data
  })
}

// 收支方式配置 查找
export function fnaAccountDetail_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/fnaAccountDetail/list',
    method: 'post',
    data: data
  })
}

// 收支方式配置 新增
export function fnaAccountDetail_add(data) {
  return request({
    url: '/qingguang/tenantbussiness/fnaAccountDetail/add',
    method: 'post',
    data: data
  })
}

// 收支方式配置 删除
export function fnaAccountDetail_delete(data) {
  return request({
    url: '/qingguang/tenantbussiness/fnaAccountDetail/delete',
    method: 'post',
    data: data
  })
}

// 收支方式配置 修改
export function fnaAccountDetail_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/fnaAccountDetail/update',
    method: 'post',
    data: data
  })
}

// 首页 模块获取数据
export function sysWorkbench_getAdminWorkbench(data) {
  return request({
    url: '/qingguang/tenantbussiness/sysWorkbench/getAdminWorkbench',
    method: 'post',
    data: data
  })
}

// 首页 待审核单据获取数据
export function sys_getUncheckCount(data) {
  return request({
    url: '/qingguang/tenantbussiness/sys/getUncheckCount',
    method: 'post',
    data: data
  })
}

// 考勤相关
// 考勤信息
export function attendanceRecord_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/attendanceRecord/list',
    method: 'post',
    data: data
  })
}

// 考勤机信息查询
export function attendanceMachine_list(data) {
  return request({
    url: '/qingguang/tenantbussiness/attendanceMachine/list',
    method: 'post',
    data: data
  })
}

// 考勤机信息添加
export function attendanceMachine_add(data) {
  return request({
    url: '/qingguang/tenantbussiness/attendanceMachine/add',
    method: 'post',
    data: data
  })
}

// 考勤机信息修改
export function attendanceMachine_update(data) {
  return request({
    url: '/qingguang/tenantbussiness/attendanceMachine/update',
    method: 'post',
    data: data
  })
}

// 考勤机信息删除
export function attendanceMachine_delete(data) {
  return request({
    url: '/qingguang/tenantbussiness/attendanceMachine/delete',
    method: 'post',
    data: data
  })
}

// 员工启用考勤机
export function attendanceMachine_distributeEmployees(data) {
  return request({
    url: '/qingguang/tenantbussiness/attendanceMachine/distributeEmployees',
    method: 'post',
    data: data
  })
}

// 员工弃用考勤机
export function attendanceMachine_deleteEmployees(data) {
  return request({
    url: '/qingguang/tenantbussiness/attendanceMachine/deleteEmployees',
    method: 'post',
    data: data
  })
}
